"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Search/Refined/SearchWindow.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactwaypoint = require('react-waypoint');

var _upgrade = require('shared/enum/upgrade');
var _useSearchQuery = require('shared/hooks/useSearchQuery');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _myRelations = require('shared/selectors/myRelations');





var _user = require('shared/selectors/user');
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _UpgradeModal = require('web/components/Upgrade/UpgradeModal'); var _UpgradeModal2 = _interopRequireDefault(_UpgradeModal);
var _hooks = require('web/services/hooks');



var _icons = require('./icons');
var _model = require('./model');

var _PillMenu = require('./PillMenu'); var _PillMenu2 = _interopRequireDefault(_PillMenu);

var _recentSearches = require('./recentSearches');
var _ResultRow = require('./ResultRow'); var _ResultRow2 = _interopRequireDefault(_ResultRow);
var _searchSession = require('./searchSession');
var _useSearchResults = require('./useSearchResults'); var _useSearchResults2 = _interopRequireDefault(_useSearchResults);

const TABS = [
  { value: 'all', label: 'All' },
  { value: 'chats', label: 'Chats' },
  { value: 'messages', label: 'Messages' },
  { value: 'files', label: 'Files' },
]

const NOT_FOUND_TITLE = {
  all: 'No results for',
  chats: 'No chats found for',
  messages: 'No messages found for',
  files: 'No files found for',
}

const SkeletonRows = ({ label }) => (
  _react2.default.createElement('div', { className: "search-window--group", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 45}}
    , _react2.default.createElement('div', { className: "search-window--group-head", __self: this, __source: {fileName: _jsxFileName, lineNumber: 46}}, label)
    , [0, 1].map(i => (
      _react2.default.createElement('div', { key: i, className: "search-window--skeleton", __self: this, __source: {fileName: _jsxFileName, lineNumber: 48}}
        , _react2.default.createElement('span', { className: "search-window--skeleton-avatar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}} )
        , _react2.default.createElement('span', { className: "search-window--skeleton-lines", __self: this, __source: {fileName: _jsxFileName, lineNumber: 50}}, _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 50}} ), _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 50}} ))
      )
    ))
  )
)










// The inbox tabs' empty state, in the search window: an icon in a soft
// circle, one title, at most one short line and one action.
const EmptyState = ({ icon, title, text, action, role }) => (
  _react2.default.createElement('div', { className: "search-window--empty", role: role, __self: this, __source: {fileName: _jsxFileName, lineNumber: 68}}
    , _react2.default.createElement('span', { className: "search-window--empty-icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 69}}, icon)
    , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 70}}, title)
    , text && _react2.default.createElement('p', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 71}}, text)
    , action && (
      _react2.default.createElement('button', { type: "button", className: "search-window--button", onClick: action.onClick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 73}}, action.label)
    )
  )
)







/**
 * The search window (plan package P7): no title bar, it
 * searches everything you can see (all your chats and teams, as today),
 * results grouped Chats, Messages, Files, and the keyboard (↑↓ to move, ↵ to
 * open).
 */
const SearchWindow = ({ onClose, restore }) => {
  const canDoAdvancedSearch = _hooks.useAppSelector.call(void 0, _user.selectCanCurrentUserDoAdvancedSearch)
  const useTestAlias = _hooks.useAppSelector.call(void 0, _user.selectCurrentUserHasTestSearchIteratorsFeature)
  const mySingleOrgKey = _hooks.useAppSelector.call(void 0, _myRelations.selectMySingleOrgKey)
  const canUpgrade = _hooks.useAppSelector.call(void 0, state => !!mySingleOrgKey && _user.selectAmIAdminInOrg.call(void 0, state, mySingleOrgKey))
  const myUserKey = _hooks.useAppSelector.call(void 0, _user.selectCurrentUserKey)

  const snapshot = _react.useMemo.call(void 0, () => (restore ? _searchSession.searchSession.get().snapshot : null), [restore])

  const [query, setQuery] = _react.useState.call(void 0, _nullishCoalesce(_optionalChain([snapshot, 'optionalAccess', _ => _.query]), () => ( '')))
  const [tab, setTab] = _react.useState(_nullishCoalesce(_optionalChain([snapshot, 'optionalAccess', _2 => _2.tab]), () => ( 'all')))
  const [daysLimit, setDaysLimit] = _react.useState.call(void 0, _nullishCoalesce(_optionalChain([snapshot, 'optionalAccess', _3 => _3.daysLimit]), () => ( (canDoAdvancedSearch ? 0 : 14))))
  const [activeId, setActiveId] = _react.useState(_nullishCoalesce(_optionalChain([snapshot, 'optionalAccess', _4 => _4.activeId]), () => ( null)))
  const [recents, setRecents] = _react.useState.call(void 0, () => _recentSearches.loadRecentSearches.call(void 0, myUserKey))
  const [isUpsellOpen, setIsUpsellOpen] = _react.useState.call(void 0, false)
  const inputRef = _react.useRef(null)

  const { results, latestQuery, status, loadMore, retry } = _useSearchResults2.default.call(void 0, {
    query, daysLimit, useTestAlias, initial: snapshot,
  })

  const items = _react.useMemo.call(void 0, () => (query ? _model.visibleItems.call(void 0, results, tab) : []), [query, results, tab])
  const navIds = _react.useMemo.call(void 0, 
    () => (query ? items.map(item => item.id) : recents.map(recent => `recent:${recent}`)),
    [query, items, recents],
  )
  // The first result is ready for ↵ once results arrive; recent searches wait
  // for an arrow key.
  const active = activeId && navIds.includes(activeId) ? activeId : (query ? _nullishCoalesce(navIds[0], () => ( null)) : null)

  _react.useEffect.call(void 0, () => {
    if (active) _optionalChain([document, 'access', _5 => _5.getElementById, 'call', _6 => _6(`search-result-${active}`), 'optionalAccess', _7 => _7.scrollIntoView, 'optionalCall', _8 => _8({ block: 'nearest' })])
  }, [active])

  const openItem = _react.useCallback.call(void 0, (item) => {
    _searchSession.searchSession.rememberSearch({ query: latestQuery, tab, daysLimit, results, activeId: item.id })
    _searchSession.searchSession.setHit(item.mKey
      ? { conversationKey: item.cKey, messageKey: item.mKey, query: latestQuery, fromWindow: true }
      : null)
    setRecents(_recentSearches.addRecentSearch.call(void 0, myUserKey, latestQuery))
    _actions2.default.gotoBlobject(item.type, item.cKey, item.bKey, item.mKey)
    onClose()
  }, [latestQuery, tab, daysLimit, results, myUserKey, onClose])

  const onQueryChange = _react.useCallback.call(void 0, (event) => {
    setQuery(_useSearchQuery.sanitizeSearchQuery.call(void 0, event.target.value))
    setActiveId(null)
  }, [])

  const pickRecent = _react.useCallback.call(void 0, (recent) => {
    setQuery(recent)
    setActiveId(null)
    _optionalChain([inputRef, 'access', _9 => _9.current, 'optionalAccess', _10 => _10.focus, 'call', _11 => _11()])
  }, [])

  const dropRecent = _react.useCallback.call(void 0, (event, recent) => {
    event.stopPropagation()
    setRecents(_recentSearches.removeRecentSearch.call(void 0, myUserKey, recent))
  }, [myUserKey])

  const onKeyDown = _react.useCallback.call(void 0, (event) => {
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault()
      if (!navIds.length) return
      const at = active ? navIds.indexOf(active) : -1
      const step = event.key === 'ArrowDown' ? 1 : -1
      const next = at === -1
        ? (step === 1 ? 0 : navIds.length - 1)
        : (at + step + navIds.length) % navIds.length
      setActiveId(_nullishCoalesce(navIds[next], () => ( null)))
    } else if (event.key === 'Enter' && active) {
      event.preventDefault()
      if (active.startsWith('recent:')) {
        pickRecent(active.slice('recent:'.length))
        return
      }
      const item = items.find(i => i.id === active)
      if (item) openItem(item)
    }
  }, [navIds, active, items, openItem, pickRecent])

  const dateOptions = _react.useMemo(() => [
    { value: '14', label: 'Last 2 weeks' },
    { value: '0', label: 'All time', disabledNote: canDoAdvancedSearch ? undefined : 'Unavailable' },
  ], [canDoAdvancedSearch])

  const onDateChange = _react.useCallback.call(void 0, (value) => {
    setDaysLimit(Number(value))
    setActiveId(null)
  }, [])

  const openUpsell = _react.useCallback.call(void 0, () => setIsUpsellOpen(true), [])
  const closeUpsell = _react.useCallback.call(void 0, () => setIsUpsellOpen(false), [])

  const dateFooter = canDoAdvancedSearch ? null : (
    _react2.default.createElement('div', { className: "search-pill--upsell", __self: this, __source: {fileName: _jsxFileName, lineNumber: 185}}
      , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 186}}, "Upgrade your plan"  )
      , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 187}}, "Upgrade to a paid plan to search your entire history."         )
      , canUpgrade && (
        _react2.default.createElement('button', { type: "button", className: "search-window--button search-window--button---accent" , onClick: openUpsell, __self: this, __source: {fileName: _jsxFileName, lineNumber: 189}}, "Upgrade"

        )
      )
    )
  )

  const hasAny = items.length > 0
  const showLimit = !!query && daysLimit !== 0 && !canDoAdvancedSearch

  const renderGroup = (group, label) => {
    const page = results[group]
    if (!page.items.length) return null
    const shown = tab === 'all' ? page.items.slice(0, _model.ALL_TAB_PER_GROUP) : page.items
    return (
      _react2.default.createElement('div', { className: "search-window--group", key: group, __self: this, __source: {fileName: _jsxFileName, lineNumber: 204}}
        , _react2.default.createElement('div', { className: "search-window--group-head", __self: this, __source: {fileName: _jsxFileName, lineNumber: 205}}
          , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 206}}, label)
          , tab === 'all' && page.totalHits > _model.ALL_TAB_PER_GROUP && (
            _react2.default.createElement('button', { type: "button", className: "search-window--show-all", onClick: () => setTab(group), __self: this, __source: {fileName: _jsxFileName, lineNumber: 208}}, "Show all "
                , page.totalHits
            )
          )
        )
        , _react2.default.createElement('ul', { className: "search-window--rows", role: "presentation", __self: this, __source: {fileName: _jsxFileName, lineNumber: 213}}
          , shown.map(item => (
            _react2.default.createElement(_ResultRow2.default, {
              key: item.id,
              item: item,
              query: latestQuery,
              active: item.id === active,
              onOpen: openItem,
              onHover: setActiveId, __self: this, __source: {fileName: _jsxFileName, lineNumber: 215}}
            )
          ))
        )
        , tab !== 'all' && page.hasMore && _react2.default.createElement(_reactwaypoint.Waypoint, { onEnter: () => loadMore(group), __self: this, __source: {fileName: _jsxFileName, lineNumber: 225}} )
      )
    )
  }

  let body
  if (!query) {
    body = (
      _react2.default.createElement('div', { className: "search-window--idle", __self: this, __source: {fileName: _jsxFileName, lineNumber: 233}}
        , recents.length > 0 && (
          _react2.default.createElement('div', { className: "search-window--group", __self: this, __source: {fileName: _jsxFileName, lineNumber: 235}}
            , _react2.default.createElement('div', { className: "search-window--group-head", __self: this, __source: {fileName: _jsxFileName, lineNumber: 236}}, "Recent searches" )
            , _react2.default.createElement('ul', { className: "search-window--rows", role: "presentation", __self: this, __source: {fileName: _jsxFileName, lineNumber: 237}}
              , recents.map(recent => {
                const id = `recent:${recent}`
                return (
                  _react2.default.createElement('li', {
                    key: recent,
                    id: `search-result-${id}`,
                    role: "option",
                    'aria-selected': id === active,
                    className: _classBuilder2.default.call(void 0, 'search-window--recent', id === active && 'search-window--row---active'),
                    onClick: () => pickRecent(recent),
                    onMouseMove: () => setActiveId(id), __self: this, __source: {fileName: _jsxFileName, lineNumber: 241}}

                    , _react2.default.createElement(_icons.ClockIcon, { size: 16, __self: this, __source: {fileName: _jsxFileName, lineNumber: 250}} )
                    , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 251}}, recent)
                    , _react2.default.createElement('button', {
                      type: "button",
                      className: "search-window--recent-remove",
                      'aria-label': `Remove \u201C${recent}\u201D from recent searches`,
                      onClick: event => dropRecent(event, recent), __self: this, __source: {fileName: _jsxFileName, lineNumber: 252}}

                      , _react2.default.createElement(_icons.CloseIcon, { size: 14, __self: this, __source: {fileName: _jsxFileName, lineNumber: 258}} )
                    )
                  )
                )
              })
            )
          )
        )
        , recents.length === 0 && (
          _react2.default.createElement(EmptyState, {
            icon: _react2.default.createElement(_icons.SearchIcon, { size: 20, __self: this, __source: {fileName: _jsxFileName, lineNumber: 268}} ),
            title: "Search your inbox"  ,
            text: "Chats, people, messages and files"    , __self: this, __source: {fileName: _jsxFileName, lineNumber: 267}}
          )
        )
      )
    )
  } else if (status === 'loading') {
    body = (
      _react2.default.createElement('div', { 'aria-busy': "true", 'aria-label': "Searching", __self: this, __source: {fileName: _jsxFileName, lineNumber: 277}}
        , _react2.default.createElement(SkeletonRows, { label: "Chats", __self: this, __source: {fileName: _jsxFileName, lineNumber: 278}} )
        , _react2.default.createElement(SkeletonRows, { label: "Messages", __self: this, __source: {fileName: _jsxFileName, lineNumber: 279}} )
      )
    )
  } else if (status === 'error') {
    body = (
      _react2.default.createElement(EmptyState, {
        role: "alert",
        icon: _react2.default.createElement(_icons.EmptySearchIcon, { size: 20, __self: this, __source: {fileName: _jsxFileName, lineNumber: 286}} ),
        title: 'Search didn\u2019t work',
        text: "Please try again."  ,
        action: { label: 'Retry', onClick: retry }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 284}}
      )
    )
  } else if (status === 'unavailable') {
    body = null
  } else if (status === 'done' && !hasAny) {
    body = (
      _react2.default.createElement(EmptyState, {
        role: "status",
        icon: _react2.default.createElement(_icons.EmptySearchIcon, { size: 20, __self: this, __source: {fileName: _jsxFileName, lineNumber: 298}} ),
        title: `${NOT_FOUND_TITLE[tab]} \u201C${latestQuery}\u201D`,
        text: "Try different words."  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 296}}
      )
    )
  } else {
    body = _model.GROUPS
      .filter(({ key }) => tab === 'all' || tab === key)
      .map(({ key, label }) => renderGroup(key, label))
  }

  return (
    _react2.default.createElement('div', { className: "search-window", __self: this, __source: {fileName: _jsxFileName, lineNumber: 310}}
      , _react2.default.createElement('div', { className: "search-window--top", __self: this, __source: {fileName: _jsxFileName, lineNumber: 311}}
        , _react2.default.createElement('button', { type: "button", className: "search-window--back", 'aria-label': "Close search" , onClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 312}}
          , _react2.default.createElement(_icons.ChevronLeftIcon, { size: 20, __self: this, __source: {fileName: _jsxFileName, lineNumber: 313}} )
        )
        , _react2.default.createElement(_icons.SearchIcon, { size: 20, className: "search-window--glass", __self: this, __source: {fileName: _jsxFileName, lineNumber: 315}} )
        , _react2.default.createElement('input', {
          ref: inputRef,
          autoFocus: true,
          className: "search-window--input",
          role: "combobox",
          'aria-expanded': navIds.length > 0,
          'aria-controls': "search-window-results",
          'aria-activedescendant': active ? `search-result-${active}` : undefined,
          'aria-label': "Search chats, people, messages and files"     ,
          placeholder: "Search chats, people, messages, files…"    ,
          value: query,
          onChange: onQueryChange,
          onKeyDown: onKeyDown, __self: this, __source: {fileName: _jsxFileName, lineNumber: 316}}
        )
        , _react2.default.createElement('button', { type: "button", className: "search-window--esc", onClick: onClose, 'aria-label': "Close search" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 330}}, "esc")
      )

      , query && (
        _react2.default.createElement('div', { className: "search-window--filters", __self: this, __source: {fileName: _jsxFileName, lineNumber: 334}}
          , _react2.default.createElement('div', { className: "search-window--tabs", role: "tablist", 'aria-label': "Result type" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 335}}
            , TABS.map(({ value, label }) => (
              _react2.default.createElement('button', {
                key: value,
                type: "button",
                role: "tab",
                'aria-selected': tab === value,
                className: _classBuilder2.default.call(void 0, 'search-window--chip', tab === value && 'search-window--chip---on'),
                onClick: () => { setTab(value); setActiveId(null) }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 337}}

                , label
              )
            ))
          )
          , _react2.default.createElement(_PillMenu2.default, {
            className: "search-window--date",
            ariaLabel: `Date range: ${daysLimit === 0 ? 'All time' : 'Last 2 weeks'}`,
            label: (
              _react2.default.createElement(_react2.default.Fragment, null
                , _react2.default.createElement(_icons.CalendarIcon, { size: 16, __self: this, __source: {fileName: _jsxFileName, lineNumber: 354}} )
                , _react2.default.createElement('span', { className: "search-window--date-label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 355}}, daysLimit === 0 ? 'All time' : 'Last 2 weeks')
              )
            ),
            value: daysLimit === 0 ? '0' : '14',
            options: dateOptions,
            onChange: onDateChange,
            footer: dateFooter, __self: this, __source: {fileName: _jsxFileName, lineNumber: 349}}
          )
        )
      )

      , _react2.default.createElement('div', { className: "search-window--body", id: "search-window-results", role: "listbox", 'aria-label': "Search results" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 366}}
        , status === 'unavailable' && (
          _react2.default.createElement('div', { className: "search-window--notice search-window--notice---danger" , role: "alert", __self: this, __source: {fileName: _jsxFileName, lineNumber: 368}}, "Elasticsearch unavailable. Search will recover automatically; please try again."

          )
        )
        , showLimit && (
          _react2.default.createElement('div', { className: "search-window--notice", __self: this, __source: {fileName: _jsxFileName, lineNumber: 373}}
            , _react2.default.createElement(_icons.ClockIcon, { size: 16, __self: this, __source: {fileName: _jsxFileName, lineNumber: 374}} )
            , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 375}}, "Your plan only includes access to 2-weeks history."       )
            , canUpgrade && (
              _react2.default.createElement('button', { type: "button", className: "search-window--link", onClick: openUpsell, __self: this, __source: {fileName: _jsxFileName, lineNumber: 377}}, "Upgrade now" )
            )
          )
        )
        , body
      )

      /* Key hints only when there is something to move through. */
      , navIds.length > 0 && (
        _react2.default.createElement('div', { className: "search-window--foot", __self: this, __source: {fileName: _jsxFileName, lineNumber: 386}}
          , _react2.default.createElement('span', { className: "search-window--keys", __self: this, __source: {fileName: _jsxFileName, lineNumber: 387}}, "↑↓ to move"  )
          , _react2.default.createElement('span', { className: "search-window--keys", __self: this, __source: {fileName: _jsxFileName, lineNumber: 388}}, query ? '↵ to open at the message' : '↵ to search again')
          , _react2.default.createElement('span', { className: "search-window--keys", __self: this, __source: {fileName: _jsxFileName, lineNumber: 389}}, "esc to close"  )
          , query && _react2.default.createElement('span', { className: "search-window--lag", __self: this, __source: {fileName: _jsxFileName, lineNumber: 390}}, "Results can lag up to ~5 min"      )
        )
      )

      , mySingleOrgKey && (
        _react2.default.createElement(_UpgradeModal2.default, {
          type: _upgrade.SubscriptionItemType.TEAM,
          isOpen: isUpsellOpen,
          onClose: closeUpsell,
          orgKey: mySingleOrgKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 395}}
        )
      )
    )
  )
}

exports. default = SearchWindow
